<template>
  <div class="chart">
    <canvas ref="chart" :width="this.width" :height="this.height"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'Chart',
  props: {
    labels: {
      type: Array,
      default () {
        return []
      }
    },
    currency: {
      type: Boolean,
      default () {
        false
      }
    },
    scales: {
      type: Object,
      default () {
        return {
          yAxes: [],
          xAxes: []
        }
      }
    },
    datasets: {
      type: Array,
      default () {
        return []
      }
    },
    type: {
      type: String,
      default () {
        return 'bar'
      }
    },
    title: {
      type: String,
      default () {
        return 'Chart'
      }
    },
    height: {
      type: Number,
      default () {
        return 400
      }
    },
    width: {
      type: Number,
      default () {
        return 400
      }
    }
  },
  data () {
    return {
      chart: false,
      callbacks: {
        label: function (tooltipItem, data) {
          return '$' + tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
      }
    }
  },
  mounted () {
    if (!this.currency) this.callbacks = {}
    this.chart = new Chart(this.$refs.chart, {
      type: this.type,
      data: {
        labels: this.labels,
        datasets: this.datasets
      },
      options: {
        maintainAspectRatio: false,
        legend: {
          position: 'bottom'
        },
        tooltips: {
          mode: 'label',
          callbacks: this.callbacks
        },
        scales: this.scales,
        title: {
          display: true,
          text: this.title
        }
      },
      plugins: [{
        afterDraw: function (chart) {
          if (chart.data.datasets[0] && chart.data.datasets[0].data.length === 0) {
            var ctx = chart.chart.ctx
            var width = chart.chart.width
            var height = chart.chart.height
            chart.clear()
            ctx.save()
            ctx.textAlign = 'center'
            ctx.textBaseline = 'middle'
            ctx.font = "16px normal 'Helvetica Nueue'"
            // chart.options.title.text <=== gets title from chart
            // width / 2 <=== centers title on canvas
            // 18 <=== aligns text 18 pixels from top, just like Chart.js
            ctx.fillText(chart.options.title.text, width / 2, 18) // <====   ADDS TITLE
            ctx.fillText('No data to display for selected time period', width / 2, height / 2)
            ctx.restore()
          }
        }
      }]
    })
  },
  methods: {
    async refresh () {
      this.chart.data.datasets = this.datasets
      this.chart.data.labels = this.labels
      await this.$nextTick()
      this.chart.update(1000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/Chart.vue